export const environment = {
  production: false,
  enablePIMAIntegration: false,
  pimaApiUrl: '',
  pimaOrigin: '',
  pimaEventRegistrationUrl: '',
  pimaProjectId: -1,
  cloudFrontUrl: 'https://vmr-cdn.tdotoutreach.com',
  survey123URL:
    'https://survey123.arcgis.com/share/5c8c8e5a72c9487db9a10e47c6dc4e57',
  adobePdfClientId: '6a1382380f5c45259dafc0ff13a4d248', // Adobe PDF Embed API Client ID (Not stored in code, stored in Amplify environment variables)
};
